// @flow

import * as React from 'react';
import classNames from '@ta/common.classnames';
import { localize } from '@ta/common.i18n';
import type { ButtonProps } from '@ta/styleguide.button';
import { Icon } from '@ta/styleguide.icon';
import { SocialLoginGate } from '@ta/social.login-gate';
import { InteractionLogger } from '@ta/tracking.interactions';
import { Toaster } from '@ta/overlays.toast';
import { NoPermissionToast } from '@ta/social.blocks';
import styles from './MessageBlock.less';

type Profile = {
  userId: string,
  blockStatus: ?{
    isBlocking: boolean,
    isBlockingYou: boolean,
  },
};

type Props = {|
  profile: Profile,
  displayType: 'button' | 'icon' | 'button+icon',
  ...ButtonProps,
|};

class MessageBlock extends React.Component<Props> {
  elt: React.ElementRef<*>;

  render() {
    const {
      displayType,
      profile: { userId, blockStatus },
      ...buttonProps
    } = this.props;

    let inner = null;
    if (displayType === 'icon') {
      inner = (
        <button
          className={classNames('ui_button', styles.greenless, {
            fullwidth: buttonProps.size === 'fullwidth',
          })}
          {...buttonProps}
        >
          <span className={styles.icon}>
            <Icon name="comments-fill" />
          </span>
        </button>
      );
    } else {
      inner = (
        <button
          className={classNames('ui_button', styles.greenless, {
            fullwidth: buttonProps.size === 'fullwidth',
          })}
          {...buttonProps}
        >
          {displayType === 'button+icon' && (
            <span className={styles.icon}>
              <Icon name="comments-fill" />
            </span>
          )}
          <span className={displayType === 'button+icon' ? styles.cta : null}>
            {localize('social_Message')} {/* Message */}
          </span>
        </button>
      );
    }

    return (
      <InteractionLogger>
        {logClick => (
          <Toaster>
            {launchToast => (
              <SocialLoginGate pid={40475}>
                {loginGate => (
                  <a
                    data-load-js="send-message-redesign"
                    data-load-css="send_message_redesign"
                    data-load-init="messaging/SendMessage"
                    data-overlay="send-message-modal"
                    data-to-id={userId}
                    data-button-location="member_profile"
                    data-ajaxnocache="true"
                    ref={elt => {
                      this.elt = elt;
                    }}
                    /* eslint-disable no-restricted-globals */
                    onClick={evt => {
                      logClick(evt, 'messageClick');
                      loginGate().then(() => {
                        if (blockStatus && (blockStatus.isBlocking || blockStatus.isBlockingYou)) {
                          launchToast({ node: <NoPermissionToast /> });
                        } else {
                          window.remoteModule(evt, this.elt);
                        }
                      });
                    }}
                  >
                    {inner}
                  </a>
                )}
              </SocialLoginGate>
            )}
          </Toaster>
        )}
      </InteractionLogger>
    );
  }
}

export default MessageBlock;
